import { motion } from 'framer-motion';
import { css } from '@emotion/css';
import { Backdrop } from '@mui/material';
import peachjarLogo from '@/assets/peachjar.png';

interface PeachjarLoaderProps {
  size?: number | string;
  alt?: string;
  loading?: boolean;
}

const styles = {
  container: css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100%',
  }),
  image: (size: number | string) =>
    css({
      width: size,
      height: size,
      display: 'block',
    }),
};

export const PeachjarLoader: React.FC<PeachjarLoaderProps> = ({
  size = 128,
  loading = true,
  alt = 'Loading...',
}) => {
  return (
    <Backdrop
      open={loading}
      sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
      aria-hidden="false"
    >
      <div className={styles.container}>
        <motion.img
          src={peachjarLogo}
          alt={alt}
          className={styles.image(size)}
          animate={{ scale: [1, 1.1, 1] }}
          transition={{
            duration: 0.8,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      </div>
    </Backdrop>
  );
};
